import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useCollections() {
  const queryCollectionByUserId = async (
    userId,
    filter,
    page,
    limit,
    project,
    sort
  ) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/collections/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const createCollection = async (userId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/collections`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const addWorkToCollection = async (userId, collectionId, workId) => {
    const _body = compress(JSON.stringify({ work: workId }));

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/collections/${collectionId}/works`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const deleteWorkFromCollection = async (userId, collectionId, workId) => {
    const result = await axios.delete(
      `${apiUri}/api/v1/users/${userId}/collections/${collectionId}/works/${workId}`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  return {
    queryCollectionByUserId,
    createCollection,
    addWorkToCollection,
    deleteWorkFromCollection,
  };
}
